import axios from 'axios';
import React, { useEffect, useState } from 'react'
import CmsLoader from '../loader/Cms1';
import { Link } from 'react-router-dom';
import Meta from './layout/Meta'

export default function Faq() {
    const [pageloader, setPageloader] = useState(false);
    const [pagedata, setPagedata] = useState();
    const [faqlists, setFaqlists] = useState([]);

    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/11')
                .then((response) => {
                    setPagedata(response.data.result);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [setPagedata]);

    useEffect(() => {
        const fetchData = async () => {
            await axios.get(process.env.REACT_APP_API + 'api/faqs').then((response) => {
                setFaqlists(response.data.result.data);
            });
        }
        fetchData();
    }, [setFaqlists]);

    return (
        <>
            <Meta id={10} />
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="FAQs" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">FAQs</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">FAQs</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="container">
                        {
                            pageloader ?
                                <CmsLoader />
                                :
                                <div className="row justify-content-center">
                                    {
                                        pagedata ?
                                            <div className="col-lg-10 col-md-11 text-center">
                                                <span className="SubTitle">{pagedata.title}</span>
                                                <h2 className="Heading">{pagedata.heading}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: pagedata.description }} />
                                            </div>
                                            :
                                            ''
                                    }

                                    {
                                        faqlists.length > 0 ?
                                            <div className="col-lg-10 col-md-11">
                                                <div className="accordion accordion-flush Faqs" id="Faqs">
                                                    {
                                                        faqlists.map((faq, f) =>
                                                            <div key={f} className="accordion-item">
                                                                <div className="accordion-header" id="Pay1">
                                                                    <button className={f === 0 ? "accordion-button" : "accordion-button collapsed"} type="button" data-bs-toggle="collapse" data-bs-target={"#Faqs" + f} aria-expanded="true" aria-controls="Faqs1">{faq.title}</button>
                                                                </div>
                                                                <div id={"Faqs" + f} className={f === 0 ? "accordion-collapse collapse show" : "accordion-collapse collapse"} aria-labelledby="Pay1" data-bs-parent="#Faqs">
                                                                    <div className="accordion-body" dangerouslySetInnerHTML={{ __html: faq.description }} />
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            :
                                            ''
                                    }


                                </div>
                        }

                    </div>
                </section>
            </main>
        </>
    )
}
